"use client";

import { useState, FormEvent } from "react";
import TaskListItem from "./taskListItem";
import {
  DailyTask,
  BuildTasksSchedule,
  Timeslot,
  occupiedTimes,
  dailyTasksAppointments
} from "../util/tasks";
import moment from "moment";
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import "./taskList.css";

export default function TaskList() {
  const [dailyTasks, setDailyTasks] = useState<Array<DailyTask>>([]);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();  
    const input = document.querySelector(
      "#task-create-input"
    ) as HTMLInputElement;
    const inputValue = input.value;
    if (!input || inputValue.replace(/\s+/g, "").length === 0) return;

    let taskContent = inputValue;
    let taskDuration = 30;
    const numberMatch = inputValue.match(/(\d+)$/);

    console.log(numberMatch);
    if (numberMatch !== null) {
      if (taskContent.replace(/(\d+)$/, "").replace(/\s+/g, "").length !== 0) {
        taskContent = taskContent.replace(/(\d+)$/, "");
      }
      let duration = Array.from(numberMatch)
        .map((number) => parseInt(number))
        .filter((x) => !Number.isNaN(x))[0];
      if (duration !== null) {
        if (duration < 15) {
          duration = 15;
        } else if (duration >= 600) {
          duration = 600;
        }
        taskDuration = duration;
      }
    }

    const task = new DailyTask(taskContent, taskDuration);
    const mutatedTasks = [...dailyTasks, task];
    setDailyTasks(mutatedTasks);
    input.value = "";
  };

  return (
    <div className="TaskList">
      <h1>Todo</h1>
      <ul>
        {dailyTasks.map((task, i) => {
          return <TaskListItem key={i} task={task} />;
        })}
        {dailyTasks.length === 0 && (
          <li id="empty-task-indicator">No tasks, start adding some !</li>
        )}
      </ul>
      <form onSubmit={(e) => handleSubmit(e)} id="create-task-form">
        <input
          type="text"
          id="task-create-input"
          autoComplete="off"
          placeholder="Add task"
        />
        <button onClick={() => submitDailyTasks()} id="generate-tasks">
          <LocalPizzaIcon />
        </button>
      </form>
    </div>
  );

  function submitDailyTasks() {
    // submit daily tasks handle
    const now = new Date();

    console.log("HIII");
    console.log(dailyTasks);

    BuildTasksSchedule(
      dailyTasks,
      15,
      true,
      occupiedTimes,
      new Date(now.setHours(9, 0, 0)),
      new Date(now.setHours(21, 0, 0))
    );

    console.log(dailyTasksAppointments.length);
    dailyTasksAppointments.forEach((task: any) => {
      console.log(task);
    });
  }
}

// function testDailyTasks() {
//   console.log("OOOKKK");

//   dailyTasks.push(new DailyTask("Test 1", 20));
//   dailyTasks.push(new DailyTask("Test 2", 45));
//   dailyTasks.push(new DailyTask("Test 3", 50));
//   dailyTasks.push(new DailyTask("Test 4", 50));
//   dailyTasks.push(new DailyTask("Test 5", 60));

//   const now = new Date();

//   console.log("HIII");
//   console.log(dailyTasks);

//   BuildTasksSchedule(
//     dailyTasks,
//     15,
//     true,
//     occupiedTimes,
//     new Date(now.setHours(9, 0, 0)),
//     new Date(now.setHours(21, 0, 0))
//   );

//   // console.log(dailyTasksAppointments);
//   console.log(dailyTasksAppointments.length);
//   dailyTasksAppointments.forEach((task) => {
//     console.log(task);
//   });
// }
